/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail } from './FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail';
import {
    instanceOfFxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail,
    FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailFromJSON,
    FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailFromJSONTyped,
    FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailToJSON,
} from './FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail';

/**
 * @type FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirement
 * 
 * @export
 */
export type FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirement = FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail;

export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementFromJSON(json: any): FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirement {
    return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementFromJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirement {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementToJSON(json: any): any {
    return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementToJSONTyped(json, false);
}

export function FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirementToJSONTyped(value?: FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementsEmailRequirement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmailToJSON(value as FxIdApplicationStoreCreatePaymentHandlerPersonalInfoRequirementEmail);
    }

    return {};
}

